import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    timecode: '^',
    play: false,
    display: [] as Array<string>,
    moment: null,
    clientId: null
  },
  mutations: {
    setClientId: (state, clientId) => (state.clientId = clientId),
    setTimecode: (state, timecode) => (state.timecode = timecode),
    setPlay: (state, play) => (state.play = play),
    addDisplay: (state, element: string) => {
      if (state.display.indexOf(element) < 0) state.display.push(element)
    },
    removeDisplay: (state, element: string) => {
      if (state.display.indexOf(element) >= 0)
        state.display.splice(state.display.indexOf(element), 1)
    },
    setMoment: (state, moment) => (state.moment = moment),
    clearMoment: state => (state.moment = null)
  }
})
